import useMutationApi from 'src/api/useMutationApi';

// these really are invoice types
const useSendEdiTransaction = (onSuccess?: () => void) => {
  const endpoint = 'famous/sales-orders/send-edi';
  return useMutationApi<{ famousSalesOrderId: string; test?: boolean }>({
    endpoint,
    method: 'POST',
    options: {
      onSuccess,
    },
  });
};

export default useSendEdiTransaction;
